export default "__VITE_ASSET__B6k3IR$F__"